var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('slide-verify',{attrs:{"l":42,"r":10,"w":400,"h":155,"imgs":_vm.slideImgs,"slider-text":'向右滑→'},on:{"success":_vm.onSuccess,"fail":_vm.onFail,"refresh":_vm.onRefresh}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }